import { CLASS_NAMES } from "../../utils/constants"
import Interactive from "./Interactive"

export default class Exit extends Interactive {
}

Exit.className = CLASS_NAMES.EXIT
